export const featuredPortfolio = [
    {
    id: 1,
    title: "React Weather App",
    img:"/assets/React weather pic 1.png",
    link:"https://brianmbh.github.io/Weather-App/"
},
    {
    id: 2,
    title: "Entrepreneur Site",
    img:"/assets/Rod Wave portfolio 1 .png",
    link:"https://brianmbh.github.io/Rod-Wave-Complete/Store.html"
},
    {
    id: 3,
    title: "Piano",
    img:"/assets/piano js.png",
    link:"https://brianspiano.netlify.app/"
},
    {
    id: 4,
    title: "Clock",
    img:"/assets/simple clock.png",
    link:"https://brianmbh.github.io/Simple-clock/"
},
];

export const emailPortfolio = [
    {
      id: 1,
      title: "Promotional Email",
      img: "/assets/promotion email.png",
      link:"https://promotionemail.netlify.app/",
    },
];

export const cssPortfolio = [
    {
      id: 1,
      title: "CSS Studio",
      img: "/assets/CSS Studio PIC.png",
      link: "https://bubblestudio.netlify.app/"
    },]